import { Chip, ChipVariants } from '@leegality/leegality-react-component-library';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';

const ReasonChip = ({
  label, slot, selected, onToggle,
}) => {
  const handleClick = useCallback(() => onToggle(slot), [onToggle, slot]);

  return <Chip label={label} variant={ChipVariants.OUTLINED} selected={selected} onClick={handleClick} />;
};

ReasonChip.propTypes = {
  label: PropTypes.string.isRequired,
  slot: PropTypes.number.isRequired,
  selected: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default memo(ReasonChip);
